import axios, { AxiosError, AxiosResponse } from 'axios';
import { baseURL } from './baseUrls';

let isRedirecting = false;
export const setupAuthInterceptor = () => {
  axios.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    async (error: AxiosError) => {
      if (error.config?.url?.includes(baseURL)) {
        const status = error.response?.status;
        const errorMessage = error.response?.data?.message || '';

        const isRedisTokenError =
          status === 401 &&
          /token not found in registered tokens list/i.test(errorMessage);

        if (isRedisTokenError && !isRedirecting) {
          isRedirecting = true;
          window.location.href = '/logout';
        }
      }

      return Promise.reject(error);
    },
  );
};
